import { initialSecurityEventsTable } from "./helper";
import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";

const initialState = {
    securityEventsTable: initialSecurityEventsTable
};

const setSecurityEventsTable = (state, action) => updateObject(state, {
    securityEventsTable: updateObject(
        state.securityEventsTable,
        { [action.key]: action.value }
    ),
});

const securityEventsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SECURITY_EVENTS:
            return setSecurityEventsTable(state, action);
        default:
            return state;
    }
};

export default securityEventsReducer;
